import { createContext, useContext } from 'react';

// Provided by LimitedShell. AppHeader reads this to know it is running inside the
// Limited Access UI (and must render the limited top bar instead of the full header).
export const LimitedShellContext = createContext(null);

export const useLimitedShell = () => useContext(LimitedShellContext);
